import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PetitionDetailsDmConfigQuery, PetitionDetailsDmConfigQueryVariables } from './getContactDmConfig.graphql';
import { PetitionDetailsDmConfig } from './getContactDmConfig.graphql';

export async function getContactDmConfig(utilityContext: UtilityContext): Promise<{
	emailSubjectLine: string;
	emailBody: readonly string[];
	emailEnabled: boolean;
}> {
	const {
		data: {
			featureConfigs: { petitionPageContactDm },
		},
	} = await utilityContext.gql.fetch<PetitionDetailsDmConfigQuery, PetitionDetailsDmConfigQueryVariables>({
		query: PetitionDetailsDmConfig,
		rejectOnError: true,
	});
	return {
		emailSubjectLine: petitionPageContactDm?.emailSubjectLine || '',
		emailBody: petitionPageContactDm?.emailBody || [''],
		// FIXME this piece of logic should probably be moved to the middle-end, in the dm.email resolver
		// so that this config (without the enabled) can be retrieved as part of the main pageData
		emailEnabled: !!petitionPageContactDm?.emailEnabled,
	};
}
